import { NetworkServer } from '~/modules/RemoteMic/Network/Server/NetworkServer';

const server = new NetworkServer();

export default server;
